const ToastState = {
    toast: true
};

export default ToastState;